export default __webpack_public_path__ + "static/implied-motion-fab-dark-438a80628837f42459c73c4f5178eb4e.mp4";